import { combineReducers } from 'redux';
import { FETCH_AAST_ZONE_SUCCESS } from '../actions/zone';
import { DISPLAY_AAST_POINT } from '../actions/points';
import { pointId } from './point';
import { Map } from 'immutable';
import keyBy from 'lodash.keyby';

const pointsToMap = (points, filterFunc) => {
  const filtered = points.filter(filterFunc).map(p => ({
    ...p,
    uid: pointId(p),
  }));

  return Map(keyBy(filtered, 'uid'));
};

const pinned = (state = Map(), action) => {
  switch (action.type) {
    case FETCH_AAST_ZONE_SUCCESS:
      return pointsToMap(action.points, p => p.coordinate !== null);
    default:
      return state;
  }
};

const displayed = (state = null, action) => {
  switch (action.type) {
    case DISPLAY_AAST_POINT:
      return action.point;
    default:
      return state;
  }
};

export default combineReducers({
  pinned,
  displayed,
});

export const getPinnedPoints = state => state.aastPlan.points.pinned.toArray();
export const getDisplayedPoint = state => state.aastPlan.points.displayed;



// WEBPACK FOOTER //
// ./src/modules/saas/aast/zones/plan/reducers/points.js